import type { RateRule } from 'state/__generated__/tadaahAPI';
import { useApiOrganisationRaterulesList } from 'state/__generated__/tadaahAPI';

interface UseGetOrganisationRateRulesHandler {
  data: RateRule[] | undefined;
  error: null | Error;
  isSuccess: boolean;
  isLoading: boolean;
}

const useGetOrganisationRateRules = (
  organisationId: string,
): UseGetOrganisationRateRulesHandler => {
  const { isLoading, data, error, isSuccess } = useApiOrganisationRaterulesList(
    organisationId,
    {
      query: {
        enabled: !!organisationId,
        queryKey: ['organisation-rate-rules', organisationId],
      },
    },
  );
  return {
    data: data?.data,
    error,
    isLoading,
    isSuccess,
  };
};

export default useGetOrganisationRateRules;
